/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./j-price.vue?vue&type=template&id=3f90e295&scoped=true"
import script from "./j-price.vue?vue&type=script&lang=js"
export * from "./j-price.vue?vue&type=script&lang=js"
import style0 from "./j-price.vue?vue&type=style&index=0&id=3f90e295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90e295",
  null
  
)

export default component.exports